import {LocalStorageFieldsEnum} from "../enums/LocalStorageFieldsEnum.enum";

export const setStorageItem = (key: LocalStorageFieldsEnum, value: any): void => {
    localStorage.setItem(key, value);
};

export const getStorageItem = (key: LocalStorageFieldsEnum): any => {
    return localStorage.getItem(key);
};